"use client";

import { AlertCircle, ClipboardList, Microscope, Pill, FileText } from "lucide-react";
import { cn } from "@/lib/utils";

interface SummaryCardProps {
  title: string;
  titleEn?: string;
  essence: string;
  emergencyLevel: string;
  keyTest: string;
  firstLineTx: string;
  paperCount?: number;
  emergency?: boolean;
}

export function SummaryCard({
  title,
  titleEn,
  essence,
  emergencyLevel,
  keyTest,
  firstLineTx,
  paperCount = 0,
  emergency = false,
}: SummaryCardProps) {
  return (
    <div
      className={cn(
        "rounded-xl border bg-card p-5 shadow-sm",
        emergency ? "border-clinical-red/30 bg-clinical-red/5" : "border-border"
      )}
    >
      <div className="mb-4">
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        {titleEn && (
          <p className="mt-0.5 text-sm text-muted-foreground">{titleEn}</p>
        )}
      </div>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="flex items-start gap-2.5">
          <div className={cn(
            "mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg",
            emergency ? "bg-clinical-red/15 text-clinical-red" : "bg-clinical-amber/15 text-clinical-amber"
          )}>
            <AlertCircle className="h-4 w-4" />
          </div>
          <div>
            <p className="text-xs font-medium text-muted-foreground">응급도</p>
            <p className="text-sm font-semibold">{emergencyLevel}</p>
          </div>
        </div>

        <div className="flex items-start gap-2.5">
          <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-clinical-blue/15 text-clinical-blue">
            <ClipboardList className="h-4 w-4" />
          </div>
          <div>
            <p className="text-xs font-medium text-muted-foreground">핵심</p>
            <p className="text-sm font-semibold">{essence}</p>
          </div>
        </div>

        <div className="flex items-start gap-2.5">
          <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-clinical-purple/15 text-clinical-purple">
            <Microscope className="h-4 w-4" />
          </div>
          <div>
            <p className="text-xs font-medium text-muted-foreground">대표검사</p>
            <p className="text-sm font-semibold">{keyTest}</p>
          </div>
        </div>

        <div className="flex items-start gap-2.5">
          <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-clinical-green/15 text-clinical-green">
            <Pill className="h-4 w-4" />
          </div>
          <div>
            <p className="text-xs font-medium text-muted-foreground">1차 치료</p>
            <p className="text-sm font-semibold">{firstLineTx}</p>
          </div>
        </div>
      </div>

      {paperCount > 0 && (
        <div className="mt-3 flex items-center gap-1.5 text-xs text-muted-foreground">
          <FileText className="h-3.5 w-3.5" />
          <span>관련 논문 {paperCount}편</span>
        </div>
      )}
    </div>
  );
}
